<template>
    <div>
        <h2 class="text-center">404</h2>
    </div>
</template>

<script>
export default {}
</script>
